"use client";

import React, { useState } from "react";
import ClientOnly from "../../ClientOnly";
import { ErrorBoundary } from "../../ErrorBoundary";
import { useFavorites } from "../hooks";
import { FavoriteItemDesktop } from "./item";
import { FavoriteOverlayItem } from "./overlayItem";
import styles from "./styles.module.scss";

export const Favorites: React.FC = () => {
    const { favorites, removeFavorite } = useFavorites();
    const [showOverlay, setShowOverlay] = useState(false);

    const favoritesToShow = favorites.slice(0, 2);
    const favoritesForOverlay = favorites.slice(2);

    return (
        <div className={styles.wrapper}>
            {favoritesToShow.map((fav) => (
                <ErrorBoundary key={fav.code}>
                    <FavoriteItemDesktop
                        code={fav.code}
                        removeFavorite={removeFavorite}
                    />
                </ErrorBoundary>
            ))}
            <ClientOnly>
                {favoritesForOverlay.length > 0 && (
                    <button
                        className={styles.showMore}
                        onClick={() => setShowOverlay(!showOverlay)}
                    >
                        <span className="icon-dropdown" />
                    </button>
                )}
                {showOverlay && (
                    <div className={styles.overlay}>
                        {favoritesForOverlay.map((fav) => (
                            <FavoriteOverlayItem
                                key={fav.code}
                                code={fav.code}
                                removeFavorite={removeFavorite}
                            />
                        ))}
                    </div>
                )}
            </ClientOnly>
        </div>
    );
};
